import _regenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import useSWRV from "swrv";
import { getData } from "@/services/axios";

import { inject, ref, watch } from 'vue';
import { isAuthenticatedKey, meKey } from '/codebuild/output/src2081543335/src/cocoo_gov/src/utils/injectionKey.js';
export default {
  __name: 'ForumIndex',
  setup: function setup(__props) {
    // @ts-check
    var isAuthenticated = inject(isAuthenticatedKey);
    var me = inject(meKey);
    var payload = ref({
      target: null
    });
    var _useSWRV = useSWRV(function () {
        return isAuthenticated.value && "forum";
      }, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var result;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getData("government_forum", payload.value);
            case 1:
              result = _context.v;
              return _context.a(2, result.items);
          }
        }, _callee);
      })), {
        refreshInterval: 0,
        revalidateOnFocus: false
      }),
      forumList = _useSWRV.data,
      mutate = _useSWRV.mutate;
    watch(function () {
      return payload.value.target;
    }, function () {
      mutate();
    });
    return {
      __sfc: true,
      isAuthenticated: isAuthenticated,
      me: me,
      payload: payload,
      forumList: forumList,
      mutate: mutate
    };
  }
};